import {
    EXTRA_GETALL_SUCCESS
  } from "../actions/types";
  
  const initialState = { extras : null }
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case EXTRA_GETALL_SUCCESS:
        return { ...state, extras: payload.extras };
      default:
        return { ...state };
    }
  }